import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'reactstrap';

import * as reservasActions from 'modules/reservas/action';
import { pickAColor } from 'core/generalFunctions';

moment.locale('es');

@connect(store => ({
  pasajero: store.getIn(['reservas', 'pasajero']),
  showListaReservas: store.getIn(['reservas', 'showListaReservas']),
  reservasPrevias: store.getIn(['reservas', 'reservasPrevias']),
  loading: store.getIn(['general', 'loadingbar', 'show']),
}))
export default class extends React.Component {
  cancelarReserva = reservaId => this.props.dispatch(reservasActions.cancelarReserva(reservaId, true, true));
  cancelarTodas = () => this.props.reservasPrevias.map(reserva => this.props.dispatch(reservasActions.cancelarReserva(reserva.get('id'), true, true)));
  render() {
    const { showListaReservas, pasajero, reservasPrevias, loading, handleSubmit } = this.props;
    return (
      <MaterialUI.Dialog
        title={`Reservas previas de ${pasajero.get('nombre')} ${pasajero.get('apellido')} `}
        modal={false}
        autoScrollBodyContent={true}
        open={showListaReservas}
        onRequestClose={() => this.props.dispatch(reservasActions.setState({ showListaReservas: false }))}
      >
        <MaterialUI.List className="noPadding dividerList">
          {reservasPrevias.map(reserva => {
            return (
              <MaterialUI.ListItem
                key={reserva.get('id')}
                disabled
                primaryText={
                  <Row>
                    <Col md="3">
                      <b>Horario:</b> {moment(reserva.get('horarioViaje')).format('HH:mm')}
                    </Col>
                    <Col md="4">
                      <b>Trayecto:</b> <span style={{ color: pickAColor(reserva.get('trayectoId')) }}>{reserva.get('nombreTrayecto')}</span>
                    </Col>
                    <Col md="4">
                      <b>Fecha del viaje:</b> {moment(reserva.get('horarioViaje')).format('DD/MM/YY')}
                    </Col>
                  </Row>
                }
                rightIconButton={
                  <MaterialUI.FlatButton icon={<FontAwesome className="iconBar red" name="trash" />} onClick={() => this.cancelarReserva(reserva.get('id'))} className="listIcon" disabled={loading} />
                }
              />
            );
          })}
          {<MaterialUI.RaisedButton className="fullWidthComponent noPadding m-tb-20" label="GUARDAR DE TODOS MODOS" primary={true} onClick={handleSubmit()} disabled={loading} />}
        </MaterialUI.List>
      </MaterialUI.Dialog>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/reservas/components/listaReservasUser.js